<template>
  <div class="min-h-screen flex items-center justify-center p-4">
    <div class="w-full max-w-md">
      <!-- Logo/Brand -->
      <div class="text-center mb-8">
        <h1 class="text-4xl font-bold mb-2">
          Stock Jockeys
        </h1>
        <p class="text-gray-600 dark:text-gray-400">
          {{ isLoginMode ? 'Welcome back!' : 'Join the competition!' }}
        </p>
      </div>

      <!-- Auth Forms -->
      <div class="transition-all duration-300 ease-in-out">
        <LoginForm 
          v-if="isLoginMode" 
          @switch-to-register="isLoginMode = false"
        />
        <RegisterForm 
          v-else 
          @switch-to-login="isLoginMode = true"
        />
      </div>

      <!-- Success Message -->
      <div v-if="successMessage" class="mt-4 alert alert-success">
        <span>{{ successMessage }}</span>
      </div>
    </div>
  </div>
</template>

<script>
import { ref, onMounted } from 'vue'
import { useRouter } from 'vue-router'
import { useAuthStore } from '../stores/auth'
import LoginForm from '../components/LoginForm.vue'
import RegisterForm from '../components/RegisterForm.vue'

export default {
  name: 'Auth',
  components: {
    LoginForm,
    RegisterForm
  },
  setup() {
    const router = useRouter()
    const authStore = useAuthStore()
    
    const isLoginMode = ref(true)
    const successMessage = ref('')

    onMounted(async () => {
      // Check if user is already authenticated
      if (authStore.isAuthenticated) {
        router.push('/')
        return
      }

      // Initialize auth state
      await authStore.initializeAuth()
      
      // If user becomes authenticated during initialization, redirect
      if (authStore.isAuthenticated) {
        router.push('/')
      }
    })

    return {
      isLoginMode,
      successMessage
    }
  }
}
</script> 